import { OrderStatistics } from 'core/models/entity/order.entities';
import { inject, injectable } from 'inversify';
import { HttpClientService } from './http-client.service';
import { Moment } from 'moment';
import { AlgoRobotPackageDetail } from '../models/entity/lepricon.entites';

const API_BASE = '/api';

@injectable()
export class LepriconService {
  @inject(HttpClientService)
  private httpClient: HttpClientService;

  public getOrderStatistics(startDate: Moment, endDate: Moment, alertName: string): Promise<OrderStatistics> {
    return this.httpClient.get(API_BASE + '/v1/orders/statistics', {
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
      alertName,
    });
  }

  public getAlgoRobotPackageDetailById(packageId: string): AlgoRobotPackageDetail {
    return this.getAlgoRobotPackageDetails().find((pkg) => pkg.id === packageId);
  }

  public getAlgoRobotPackageDetails(): AlgoRobotPackageDetail[] {
    return [
      {
        id: 'alpha-trader-pro',
        name: 'BIST - AlphaTraderPro',
        alertName: 'v10_20DK_D_3_20_21::PKT1',
        description: 'Alfa Kararlar Alan, Piyasalardaki Potansiyel Fırsatları Değerlendiren Trading Bot Paketi',
      },
      {
        id: 'mega-trader-x',
        name: 'BIST - MegaTraderX',
        alertName: 'v10_20DK_W_1_20_2::PKT1',
        description: 'Orta Vadeli Alım Fırsatlarını Değerlendiren Trading Bot Paketi',
      },
      {
        id: 'opti-bot-x',
        name: 'BIST - OptiBotX',
        alertName: 'v10_20DK_D_5_15_21::PKT1',
        description: 'Optimal Fırsatları Yakalamak İçin Geliştirilmiş Algoritmalar Ve Stratejilerle Desteklenen Trading Bot Paketi',
      },
      {
        id: 'dividend-prime-bot',
        name: 'BIST - DividendPrimeBot',
        alertName: 'v10_20DK_MIX_TEMETTU::PKT1',
        description: 'Temettü Verimi Yüksek Ve Güvenilir Hisselerden Oluşan Trading Bot Paketi',
      },
      {
        id: 'power-house',
        name: 'NASDAQ - PowerHouse',
        alertName: 'nasdaq_20DK:NASDAQ1',
        description: "NASDAQ'da Yer Alan Devasa Şirketlerin Bulunduğu Trading Bot Paketi",
      },
      {
        id: 'coin-matrix',
        name: 'CRYPTO - CoinMatrix',
        alertName: 'crypto_60DK::CRYPTO1',
        description: 'Kripto Dünyasının En Popüler Coinlerini Kapsayan Trading Bot Paketi',
      },
    ];
  }
}
